import {Component, OnInit} from '@angular/core';
import {FormBuilder, FormGroup} from '@angular/forms';
import {ApiService} from '../../api.service';
import {MessageTypes} from '../../message';
import {MessageService} from '../../message.service';

@Component({
    selector: 'app-password',
    templateUrl: './password.component.html',
    styleUrls: ['./password.component.css']
})
export class PasswordComponent implements OnInit {
    private passwordForm: FormGroup;
    public password = {oldpassword: '', newpassword1: '', newpassword2: ''};
    public submitLabel = 'Change';
    constructor(protected apiService: ApiService, protected messageService: MessageService) {
    }

    ngOnInit() {
    }

    submit() {
        this.submitLabel = 'Saving ...';
        this.apiService.post('authenticate',
            this.password)
            .subscribe(
                (value: any) => {
                    this.messageService.setMessage('Password got updated', MessageTypes.Success);
                    this.submitLabel = 'Change';
                }, (err) => {
                    console.log('error when trying to update password', err);
                    this.messageService.setMessage('An error occurred - the password didn`t get updated', MessageTypes.Error);
                    this.submitLabel = 'Change';
                }
                );
    }
}



// WEBPACK FOOTER //
// ./src/app/account/password/password.component.ts